import { render, staticRenderFns } from "./PcAboutUsNew.vue?vue&type=template&id=37b96dde&scoped=true&"
import script from "./PcAboutUsNew.vue?vue&type=script&lang=js&"
export * from "./PcAboutUsNew.vue?vue&type=script&lang=js&"
import style0 from "./PcAboutUsNew.vue?vue&type=style&index=0&id=37b96dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b96dde",
  null
  
)

export default component.exports